import { fonts } from '@local/web-design-system/styles';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

// Use darkTheme primary from https://marvelapp.com/prototype/j8fj4a7/screen/90729204
const LINK_HOVER_COLOR = '#007cb5';

export const useStyles = makeStyles<{ imageList: string }>()((theme: Theme, { imageList }) => ({
    root: {
        backgroundImage: imageList,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100vh',
    },
    column: {
        height: '100vh',
        padding: theme.spacing(6),
        boxSizing: 'border-box',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '50vh',
        },
    },
    columnLeft: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            height: '50vh',
            justifyContent: 'center',
            alignItems: 'flex-end',
        },
    },
    columnRight: {
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
        },
    },
    logo: {
        width: theme.spacing(25),
        height: theme.spacing(5),
    },
    formContainer: {
        backgroundImage:
            'linear-gradient(0deg, rgba(29, 31, 35, 0.76) 0%, rgba(29, 31, 35, 0.9) 100%)',
    },
    copy: {
        ...fonts.comment,
        color: 'white',
        position: 'absolute',
        left: theme.spacing(12),
        bottom: theme.spacing(3),
        '@media (max-width: 776px)': {
            bottom: theme.spacing(6),
        },
    },
    divider: {
        border: `1px solid ${theme.palette.grey[200]}`,
        color: theme.palette.grey[50],
        height: theme.spacing(2),
    },
    footer: {
        color: theme.palette.grey[50],
        position: 'absolute',
        bottom: theme.spacing(3),
        right: theme.spacing(8),
        alignItems: 'center',
        justifyContent: 'right',
        '& a': {
            ...fonts.linkText,
            color: theme.palette.grey[400],
            '&:hover': {
                color: LINK_HOVER_COLOR,
            },
        },
    },
}));

export const useHiddenApiSelectorStyles = makeStyles()((theme: Theme) => ({
    hiddenApiSelector: {
        position: 'fixed',
        top: 0,
        width: '100%',
        height: theme.spacing(6),
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        zIndex: 1000,
        [theme.breakpoints.down('sm')]: {
            top: theme.spacing(1),
            right: theme.spacing(1),
        },
    },
}));
